(function () {
  // Wyszukiwarka Routines: przeszukiwanie po tagach, placeholder, podpowiedzi wskazan,
  // rekomendacje produktowe, dopisek o dopasowaniu, szybkie dodanie do koszyka
  // oraz reczniki jako dodatek - zawsze na koncu listy, nigdy przed kosmetykiem.
  var PLACEHOLDER = 'Szukaj produktu, składnika lub wskazania';
  var PODPOWIEDZI = ['trądzik', 'przebarwienia', 'zaczerwienienia', 'sucha skóra', 'cera tłusta', 'zmarszczki', 'rozświetlenie', 'SPF', 'nawilżenie', 'oczyszczanie', 'mycie twarzy', 'peeling', 'anti-aging', 'wypryski'];
  var POLECANE = [
    'routines-serum-wodne-ai-przeciw-niedoskonalosciom-step-3-30ml',
    'routines-serum-z-witamina-c-redukujace-zaczerwienienia-step-3-30ml',
    'routines-krem-z-filtrem-ochrona-uv-spf-50-step-4-50ml',
    'routines-krem-nawilzajacy-lagodzacy-step-4-50ml'
  ];

  var DODATEK = {
    handle: 'reczniki-jednorazowe-do-twarzy',
    etykieta: 'Uzupełnij oczyszczanie',
    powod: 'Osuszanie bez pocierania i bez wspólnego ręcznika — mniej podrażnień przy cerze wrażliwej i z wypryskami.'
  };
  var TRIGGERY = ['trądzik', 'tradzik', 'wypryski', 'wyprysk', 'niedoskonałości', 'niedoskonalosci', 'cera wrażliwa', 'wrażliwa', 'wrazliwa', 'zaczerwienienia', 'zaczerwienienie', 'podrażnienia', 'podraznienia', 'oczyszczanie', 'mycie twarzy', 'mycie', 'demakijaż', 'demakijaz', 'pianka', 'żel myjący', 'zel myjacy', 'galaretka', 'maseczka', 'maska'];

  var IKONA_KOSZYK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="20" r="1.4"/><circle cx="18" cy="20" r="1.4"/><path d="M2 3h3l2.6 12.2a1.6 1.6 0 0 0 1.6 1.3h8.4a1.6 1.6 0 0 0 1.6-1.3L21 7H6"/></svg>';
  var IKONA_OK = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M4 12.5l5 5L20 6.5"/></svg>';
  var IKONA_OPCJE = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';
  var cache = {};

  function zl(gr) { return (gr / 100).toFixed(2).replace('.', ',') + ' zł'; }

  function styl() {
    if (document.getElementById('rs-style')) return;
    var s = document.createElement('style');
    s.id = 'rs-style';
    s.textContent =
      '#drawer-search-form .hdt-search-head h5{font-family:Barlow,var(--font-body-family,sans-serif)!important}' +
      '#drawer-search-form .hdt-search-content-title{display:none!important}' +
      '#drawer-search-form [data-input-search]::placeholder{color:#8a8a8a!important;opacity:1!important}' +
      '#drawer-search-form [data-input-search].rs-ph-hide::placeholder{color:transparent!important}' +
      '#drawer-search-form [data-results-search] .hdt-card-product__title{font-weight:700!important}' +
      '#drawer-search-form [data-results-search] .hdt-card-product{position:relative}' +
      '#drawer-search-form [data-results-search] .hdt-card-product__info{padding-right:44px}' +
      '.rs-chips{display:flex;flex-wrap:wrap;gap:8px;margin:2px 0 22px}' +
      '.rs-chip{font-family:Barlow,var(--font-body-family,sans-serif);font-size:13px;line-height:1;padding:9px 14px;border:1px solid #000;border-radius:999px;background:#fff;color:#000;cursor:pointer;transition:background .15s,color .15s}' +
      '.rs-chip:hover{background:#000;color:#fff}' +
      '.rs-title{font-family:Barlow,var(--font-body-family,sans-serif);font-size:12px;letter-spacing:.5px;text-transform:uppercase;color:#8a7f65;margin:0 0 10px}' +
      '.rs-rec{display:flex;flex-direction:column;gap:12px;margin-bottom:6px}' +
      '.rs-rec-item{display:flex;align-items:center;gap:12px}' +
      '.rs-rec-link{display:flex;align-items:center;gap:12px;text-decoration:none;flex:1;min-width:0}' +
      '.rs-rec-item img{width:48px;height:48px;object-fit:cover;border-radius:6px;background:#f4f1ea;flex-shrink:0}' +
      '.rs-rec-name{font-family:Barlow,var(--font-body-family,sans-serif);font-size:13px;font-weight:700;color:#000;line-height:1.3;display:block}' +
      '.rs-rec-price{font-family:Barlow,var(--font-body-family,sans-serif);font-size:13px;color:#000;margin-top:2px;display:block}' +
      '.rs-rec-old{color:#999;text-decoration:line-through;margin-right:6px;font-size:12px}' +
      '.rs-cart{flex-shrink:0;width:34px;height:34px;border:none;border-radius:50%;background:#000;color:#fff;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;padding:0;transition:opacity .15s}' +
      '.rs-cart:hover{opacity:.82}' +
      '.rs-cart--ok{background:#2e9e5b}' +
      '.rs-cart--off{background:#dcd8d0;color:#fff;cursor:default}' +
      '.rs-cart--off:hover{opacity:1}' +
      '#drawer-search-form [data-results-search] .rs-cart{position:absolute;right:4px;top:50%;transform:translateY(-50%);z-index:5}' +
      '.rs-match{font-family:Barlow,var(--font-body-family,sans-serif);font-size:11.5px;line-height:1.35;color:#6b6b6b;margin:3px 0 0}' +
      '.rs-match strong{color:#000;font-weight:600}' +
      '.rs-pin-wrap{list-style:none;margin:16px 0 4px;padding:0}' +
      '.rs-pin-label{font-family:Barlow,var(--font-body-family,sans-serif);font-size:10.5px;letter-spacing:.6px;text-transform:uppercase;color:#8a7f65;margin:0 0 8px;display:block}' +
      '.rs-pin{display:flex;align-items:center;gap:12px;padding:12px;background:#f7f4ec;border-radius:8px}' +
      '.rs-pin-link{display:flex;align-items:center;gap:12px;text-decoration:none;flex:1;min-width:0}' +
      '.rs-pin img{width:48px;height:48px;object-fit:cover;border-radius:6px;background:#fff;flex-shrink:0}' +
      '.rs-pin-name{font-family:Barlow,var(--font-body-family,sans-serif);font-size:13px;font-weight:700;color:#000;line-height:1.3;display:block}' +
      '.rs-pin-why{font-family:Barlow,var(--font-body-family,sans-serif);font-size:11.5px;line-height:1.35;color:#6b6b6b;margin:3px 0 0}' +
      '.rs-pin-why strong{color:#8a7f65;font-weight:600;text-transform:uppercase;letter-spacing:.4px;font-size:10.5px;display:block;margin-bottom:2px}' +
      '.rs-pin-price{font-family:Barlow,var(--font-body-family,sans-serif);font-size:13px;color:#000;margin-top:3px;display:block}';
    document.head.appendChild(s);
  }

  function wlaczTagi() {
    document.querySelectorAll('input[name="resources[options][fields]"]').forEach(function (i) {
      var v = i.value || '';
      if (v.split(',').indexOf('tag') === -1) i.value = v ? v + ',tag' : 'title,tag';
    });
  }

  function ustawPlaceholder() {
    document.querySelectorAll('[data-input-search]').forEach(function (i) {
      if (i.getAttribute('placeholder') !== PLACEHOLDER) i.setAttribute('placeholder', PLACEHOLDER);
      if (i.getAttribute('data-rs-ph') === '1') return;
      i.setAttribute('data-rs-ph', '1');
      i.addEventListener('click', function (e) { if (e.isTrusted) i.classList.add('rs-ph-hide'); });
      i.addEventListener('input', function (e) { if (e.isTrusted) i.classList.add('rs-ph-hide'); });
      i.addEventListener('blur', function () { if (!i.value) i.classList.remove('rs-ph-hide'); });
    });
  }

  function szukaj(fraza) {
    var input = document.querySelector('#drawer-search-form [data-input-search]') || document.querySelector('[data-input-search]');
    if (!input) return;
    wlaczTagi();
    input.classList.add('rs-ph-hide');
    input.value = fraza;
    input.focus();
    ['input', 'keyup', 'change'].forEach(function (ev) { input.dispatchEvent(new Event(ev, { bubbles: true })); });
  }

  function pobierz(handle) {
    if (cache[handle] !== undefined) return Promise.resolve(cache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { if (!r.ok) throw new Error(handle); return r.json(); })
      .then(function (p) { cache[handle] = p; return p; })
      .catch(function () { cache[handle] = null; return null; });
  }

  // Kazdy wynik dostaje kontrolke, ale zachowanie zalezy od stanu produktu:
  // jeden dostepny wariant - dodaje od razu; kilka - prowadzi do wyboru; brak - szary, nieaktywny.
  function przyciskKoszyka(produkt) {
    if (!produkt) return null;
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'rs-cart';

    var dostepne = (produkt.variants || []).filter(function (v) { return v.available; });

    if (!produkt.available || !dostepne.length) {
      b.className = 'rs-cart rs-cart--off';
      b.disabled = true;
      b.innerHTML = IKONA_KOSZYK;
      b.title = 'Chwilowo niedostępny';
      b.setAttribute('aria-label', 'Chwilowo niedostępny: ' + produkt.title);
      return b;
    }

    if (dostepne.length > 1) {
      b.innerHTML = IKONA_OPCJE;
      b.title = 'Wybierz wariant';
      b.setAttribute('aria-label', 'Wybierz wariant: ' + produkt.title);
      b.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        window.location.href = '/products/' + produkt.handle;
      });
      return b;
    }

    b.innerHTML = IKONA_KOSZYK;
    b.title = 'Dodaj do koszyka';
    b.setAttribute('aria-label', 'Dodaj do koszyka: ' + produkt.title);
    b.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (b.disabled) return;
      b.disabled = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: dostepne[0].id, quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); })
        .then(function () { return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); }); })
        .then(function (koszyk) {
          b.classList.add('rs-cart--ok');
          b.innerHTML = IKONA_OK;
          b.setAttribute('aria-label', 'Dodano do koszyka: ' + produkt.title);
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: koszyk } }));
          setTimeout(function () {
            b.classList.remove('rs-cart--ok');
            b.innerHTML = IKONA_KOSZYK;
            b.setAttribute('aria-label', 'Dodaj do koszyka: ' + produkt.title);
            b.disabled = false;
          }, 1800);
        })
        .catch(function () { b.disabled = false; });
    });
    return b;
  }

  function wstawPanel() {
    var drawer = document.getElementById('drawer-search-form');
    if (!drawer || drawer.querySelector('.rs-chips')) return;
    var kotwica = drawer.querySelector('.hdt-search-hidden-inner') || drawer.querySelector('.hdt-col-content');
    if (!kotwica) return;

    var wrap = document.createElement('div');
    var t1 = document.createElement('p');
    t1.className = 'rs-title';
    t1.textContent = 'Popularne wskazania';
    var chips = document.createElement('div');
    chips.className = 'rs-chips';
    PODPOWIEDZI.forEach(function (p) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rs-chip';
      b.textContent = p;
      b.addEventListener('click', function () { szukaj(p); });
      chips.appendChild(b);
    });
    var t2 = document.createElement('p');
    t2.className = 'rs-title';
    t2.textContent = 'Polecamy';
    var lista = document.createElement('div');
    lista.className = 'rs-rec';

    wrap.appendChild(t1);
    wrap.appendChild(chips);
    wrap.appendChild(t2);
    wrap.appendChild(lista);
    kotwica.parentNode.insertBefore(wrap, kotwica);

    POLECANE.forEach(function (h) {
      pobierz(h).then(function (p) {
        if (!p) return;
        var row = document.createElement('div');
        row.className = 'rs-rec-item';
        var a = document.createElement('a');
        a.className = 'rs-rec-link';
        a.href = '/products/' + p.handle;
        var img = document.createElement('img');
        img.loading = 'lazy';
        img.alt = '';
        img.src = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=96' : '';
        var info = document.createElement('span');
        var nazwa = document.createElement('span');
        nazwa.className = 'rs-rec-name';
        nazwa.textContent = p.title;
        var cena = document.createElement('span');
        cena.className = 'rs-rec-price';
        var v = p.variants[0];
        if (v.compare_at_price && v.compare_at_price > v.price) {
          var stara = document.createElement('span');
          stara.className = 'rs-rec-old';
          stara.textContent = zl(v.compare_at_price);
          cena.appendChild(stara);
        }
        cena.appendChild(document.createTextNode(zl(v.price)));
        info.appendChild(nazwa);
        info.appendChild(cena);
        a.appendChild(img);
        a.appendChild(info);
        row.appendChild(a);
        var btn = przyciskKoszyka(p);
        if (btn) row.appendChild(btn);
        lista.appendChild(row);
      });
    });
  }

  function pasujeDoTriggera(q) {
    if (q.length < 3) return false;
    for (var i = 0; i < TRIGGERY.length; i++) {
      var t = TRIGGERY[i];
      if (q.indexOf(t) > -1 || t.indexOf(q) > -1) return true;
    }
    return false;
  }

  function oRecznikach(q) { return q.indexOf('ręcznik') > -1 || q.indexOf('recznik') > -1; }

  function etykietaPowodu() {
    var el = document.createElement('p');
    el.className = 'rs-pin-why';
    var s = document.createElement('strong');
    s.textContent = DODATEK.etykieta;
    el.appendChild(s);
    el.appendChild(document.createTextNode(DODATEK.powod));
    return el;
  }

  function przesunDodatek(box, q) {
    if (oRecznikach(q)) return true;
    var a = box.querySelector('a[href*="' + DODATEK.handle + '"]');
    if (!a) return false;
    var karta = a.closest('.hdt-pr-loop, .hdt-product, .hdt-card-product, li') || a.parentElement;
    if (!karta || !karta.parentNode) return false;
    var rodzic = karta.parentNode;
    if (rodzic.lastElementChild !== karta) rodzic.appendChild(karta);
    if (!karta.querySelector('.rs-pin-why')) {
      (karta.querySelector('.hdt-card-product__info') || karta).appendChild(etykietaPowodu());
    }
    return true;
  }

  function przypnijDodatek(box, q) {
    var stary = document.getElementById('rs-pin');
    if (stary && stary.getAttribute('data-rs-q') === q) return;
    if (stary && stary.parentNode) stary.parentNode.removeChild(stary);
    if (!pasujeDoTriggera(q)) return;

    pobierz(DODATEK.handle).then(function (p) {
      if (!p || !p.available) return;
      var input = document.querySelector('#drawer-search-form [data-input-search]');
      if (!input || (input.value || '').trim().toLowerCase() !== q) return;
      if (document.getElementById('rs-pin')) return;
      if (box.querySelector('a[href*="' + DODATEK.handle + '"]')) return;

      var karty = box.querySelectorAll('a[href*="/products/"]');
      var ostatnia = null;
      if (karty.length) {
        var a0 = karty[karty.length - 1];
        ostatnia = a0.closest('.hdt-pr-loop, .hdt-product, .hdt-card-product, li') || a0.parentElement;
      }

      var wrap = document.createElement(ostatnia ? ostatnia.tagName : 'div');
      wrap.className = 'rs-pin-wrap';
      wrap.id = 'rs-pin';
      wrap.setAttribute('data-rs-q', q);

      var label = document.createElement('span');
      label.className = 'rs-pin-label';
      label.textContent = DODATEK.etykieta;

      var row = document.createElement('div');
      row.className = 'rs-pin';
      var a = document.createElement('a');
      a.className = 'rs-pin-link';
      a.href = '/products/' + p.handle;
      var img = document.createElement('img');
      img.loading = 'lazy';
      img.alt = '';
      img.src = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=96' : '';
      var info = document.createElement('span');
      var nazwa = document.createElement('span');
      nazwa.className = 'rs-pin-name';
      nazwa.textContent = p.title;
      var why = document.createElement('p');
      why.className = 'rs-pin-why';
      why.textContent = DODATEK.powod;
      var cena = document.createElement('span');
      cena.className = 'rs-pin-price';
      var v = p.variants[0];
      if (v.compare_at_price && v.compare_at_price > v.price) {
        var stara = document.createElement('span');
        stara.className = 'rs-rec-old';
        stara.textContent = zl(v.compare_at_price);
        cena.appendChild(stara);
      }
      cena.appendChild(document.createTextNode(zl(v.price)));
      info.appendChild(nazwa);
      info.appendChild(why);
      info.appendChild(cena);
      a.appendChild(img);
      a.appendChild(info);
      row.appendChild(a);
      var btn = przyciskKoszyka(p);
      if (btn) row.appendChild(btn);
      wrap.appendChild(label);
      wrap.appendChild(row);

      if (ostatnia && ostatnia.parentNode) ostatnia.parentNode.insertBefore(wrap, ostatnia.nextSibling);
      else box.appendChild(wrap);
    });
  }

  function wzbogacWyniki() {
    var input = document.querySelector('#drawer-search-form [data-input-search]');
    if (!input) return;
    var q = (input.value || '').trim().toLowerCase();
    var box = document.querySelector('#drawer-search-form [data-results-search]');
    if (!box) return;
    box.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.closest('.rs-pin-wrap')) return;
      var karta = a.closest('.hdt-pr-loop, .hdt-product, .hdt-card-product, li') || a.parentElement;
      if (!karta) return;
      if (karta.getAttribute('data-rs-q') === q) return;
      karta.setAttribute('data-rs-q', q);
      var stary = karta.querySelector('.rs-match');
      if (stary) stary.parentNode.removeChild(stary);
      var m = a.getAttribute('href').match(/\/products\/([^?#\/]+)/);
      if (!m) return;
      pobierz(m[1]).then(function (p) {
        if (!p) return;
        if (!karta.querySelector('.rs-cart')) {
          var btn = przyciskKoszyka(p);
          if (btn) karta.appendChild(btn);
        }
        if (q.length < 3) return;
        if (String(p.title || '').toLowerCase().indexOf(q) > -1) return;
        var trafiony = null;
        (p.tags || []).forEach(function (t) {
          if (trafiony) return;
          var td = String(t).toLowerCase();
          if (td.indexOf(q) > -1 || q.indexOf(td) > -1) trafiony = t;
        });
        if (!trafiony || karta.querySelector('.rs-match') || karta.querySelector('.rs-pin-why')) return;
        var el = document.createElement('p');
        el.className = 'rs-match';
        el.appendChild(document.createTextNode('Pasuje do: '));
        var s = document.createElement('strong');
        s.textContent = trafiony;
        el.appendChild(s);
        (karta.querySelector('.hdt-card-product__info') || karta).appendChild(el);
      });
    });
    if (!przesunDodatek(box, q)) przypnijDodatek(box, q);
  }

  var timer = null;
  function zaplanuj() { clearTimeout(timer); timer = setTimeout(wzbogacWyniki, 250); }

  function start() {
    styl();
    wlaczTagi();
    ustawPlaceholder();
    wstawPanel();
    var drawer = document.getElementById('drawer-search-form');
    if (!drawer) return;
    new MutationObserver(function () {
      wlaczTagi();
      ustawPlaceholder();
      wstawPanel();
      zaplanuj();
    }).observe(drawer, { childList: true, subtree: true });
    var input = drawer.querySelector('[data-input-search]');
    if (input) input.addEventListener('input', function () { wlaczTagi(); zaplanuj(); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); }
  else { start(); }
})();
